/**
 * Core
 */
import {
  CONST_GENDER_FEMALE,
  CONST_GENDER_MALE,
  isValidGender,
  simplyClick,
} from "../../helpers";
import { ContextProfileUser } from "../../lib/profileContext";
import { useContext, useState } from "react";

/**
 *Styles
 */
import "./Gender.scss";

const Gender = ({ setStep, step }) => {
  const { data, setData } = useContext(ContextProfileUser);
  const [errorGender, setErrorGender] = useState(null);

  const handleChangeGender = ({ target: { value } }) => {
    setErrorGender(null);
    if (!isValidGender(data?.gender)) {
      setErrorGender("Please, choose your gender ");
    } else {
      setData({ ...data, gender: value.toString() });
      setStep(step + 1);
    }
  };
  return (
    <div className="gender__wrap">
      <h3>Want to know a secret?</h3>
      <p>Witty and gorgeous singles are waiting for you.</p>
      <video
        autoPlay
        loop
        muted
        playsInline
        preload={"yes"}
        poster="./assets/images/poster.jpg"
      >
        <source src="./assets/video/video.webm" type="video/webm" />
        <source src="./assets/video/video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="gender__form">
        <h5 className="form__title">You are a</h5>
        <div className="radio__wrap">
          <label className="male">
            <input
              onChange={(e) => handleChangeGender(e)}
              onClick={() => simplyClick("cl_lnd_am30_gender_male")}
              type="radio"
              name="gender"
              value={CONST_GENDER_MALE}
              data-gender="gender"
            />
            <span className="custom-radio male"></span>
            Man
          </label>
          <label className="female">
            <input
              onChange={(e) => handleChangeGender(e)}
              onClick={() => simplyClick("cl_lnd_am30_gender_female")}
              type="radio"
              name="gender"
              value={CONST_GENDER_FEMALE}
              data-gender="gender"
            />
            <span className="custom-radio female"></span>
            Woman
          </label>
        </div>
        {!errorGender && <p className="error-text">{errorGender}</p>}
      </div>
    </div>
  );
};
export default Gender;
